import { Link } from "react-router-dom";
import AddWorkExperienceForm from "./AddWorkExperienceForm";

const AddWorkExperience = () => {
	return (
		<div className="form-page d-flex justify-content-center align-items-center py-2">
			<div className="add-profile form-container bg-white pt-3 pb-3 px-sm-4 px-3 ">
				<div className="progresss d-flex justify-content-center">
					<span className="active"></span>
					<span className="active"></span>
					<span></span>
					<span></span>
				</div>
				<h3 className="text-center fw-bold mb-3">Work experience</h3>

				<AddWorkExperienceForm />

				<div className="d-flex justify-content-end mt-n3">
					<Link
						className="btn btn-outline-secondary px-5 mt-n4"
						to="/addeducation"
					>
						Skip
					</Link>
				</div>
			</div>
		</div>
	);
};

export default AddWorkExperience;
